module.exports = __webpack_public_path__ + "testimonial1.png?9eb887acbadb9b920e57a44736872f12";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonial1.png
// module id = 366
// module chunks = 0